import { Accordion } from './Accordion';

export function initFAQAccordionModule() {
  //  FAQ Accordion
  $('.questions__question h4').click(function () {
    const question = $(this).parent();
    question.find('p').slideToggle();
    question.toggleClass(
      'questions__question--expended questions__question--collapsed'
    );
  });

  //  FAQ Accordion
  $('.module-compare-dna-dnb .compare-chart__feature h4').click(function () {
    if ($(window).width() > '750') {
      return;
    }

    $(this).toggleClass('toggled');

    const description = $(this)
      .parents('tr')
      .next('tr.compare-chart__feature_description');
    description.stop().slideToggle();
    description.toggleClass(
      'compare-chart__feature_description--expanded compare-chart__feature_description--collapsed'
    );
  });
}

export function initCompareChartAccordion() {
  // Make the feature slideToggle on Mobile
  const compareChartAccordion = new Accordion('.feature__name');
  const mediumDownMediaQuery = window.matchMedia('(max-width: 48em)');

  // If we're on mobile or tablet, setup the accordion
  if (mediumDownMediaQuery.matches) {
    compareChartAccordion.setup();
  }

  // listen for MediaQuery change and setup/destroy accordion accordingly.

  const onMediaQueryChange = (e) => {
    if (e.matches) {
      compareChartAccordion.setup();
    } else {
      compareChartAccordion.destroy();
    }
  };

  if (typeof mediumDownMediaQuery.addEventListener === 'function') {
    mediumDownMediaQuery.addEventListener('change', onMediaQueryChange);
  }
}
